import { types, flow, getParent } from 'mobx-state-tree';
import { user } from "@myplay/all";
import { toast } from "@myplay/ui";

import { CURRENT_CLUB_ID } from '../../utils/constants';
import storage from "../../utils/storage";
import I18N from '../../I18N';
import history from "../../utils/history";

const clubsModule = user.clubs;
const authModule = user.auth;

const ClubsStore = types
  .model({
    clubs: types.array(types.frozen({})),
    currentClub: types.frozen({})
  })
  .actions(self => ({
    getClubsByUser: flow(function* getClubsByUser(userId) {
      try {
        const { CategoriesStore } = getParent(self);
        const clubs = yield clubsModule.getClubsList(userId);
        CategoriesStore.getCategories();
        const currentClubId = yield storage.getItem(CURRENT_CLUB_ID);
        const currentClub = yield clubsModule.getClubById(currentClubId || clubs[0]._id);
        self.setClub(currentClub);
        self.clubs = [ ...clubs ];
      } catch (error) {
        console.log(error);
      }
    }), 
    getClubTeams: flow(function* getClubTeams() {
      try {
        const { TeamsStore } = getParent(self);
        const { currentClub, clubs } = self;
        const { teams } = yield clubsModule.getClubTeams(currentClub.club._id);
        const clubIndex = clubs.findIndex(club => club._id === currentClub.club._id);
        const newClub = { ...self.clubs[clubIndex], teams: [...teams] };
        TeamsStore.setTeams(teams);
        self.clubs[clubIndex] = { ...newClub };
        self.currentClub = {...newClub};
      } catch (error) {
        console.log(error);
      }
    }),  
    sendUserInvitation: flow(function* sendUserInvitation(user, accountType){
      try {
        return yield authModule.sendUserInvitation({
          team: user.team.id, 
          email: user.email, 
          accountType
        });
      } catch (error) {
        console.log(error);
        throw new Error(error);
      }
    }), 
    sendInvitations: flow(function* sendInvitations(users, accountType){
      try {
        yield Promise.all(
          users.map(user => self.sendUserInvitation(user, accountType))
        );
        const toastText = users.length > 1 ?
          `${I18N.t("INVITATION_SENT")} ${users.length} ${I18N.t("USERS")}` :
          `${I18N.t("INVITATION_SENT")} ${users[0].email}`
        toast.success(toastText);
      } catch (error) {
        toast.error(I18N.t("SOMETHING_WENT_WRONG"));
        console.log(error);
      }
    }), 
    getClubById: flow(function* getClubById(clubId){
      try {
        const club = yield clubsModule.getClubById(clubId);
        self.setClub(club);
      } catch (error) {
        console.log(error);
      }
    }), 
    setClub(club) {
      const { TeamsStore, SitesStore, CoachesStore, VideosStore, MetricsStore } = getParent(self);
      const { teams, sites } = club;
      if (teams && teams.length > 0) {
        TeamsStore.setTeams(teams);
        CoachesStore.setCoachesFromClub(club);
      };

      if (sites && sites.length > 0) {
        SitesStore.setSites(sites);
      };
      storage.setItem(CURRENT_CLUB_ID, club.club._id);
      self.currentClub = { ...club }
      MetricsStore.setClubMetrics();
      VideosStore.getClubVideos(self.currentClub.club._id);
    }, 
    updateClubLogo: flow(function* updateClubLogo(image) {
      try {
        const { _id } = self.currentClub.club;
        const newLogo = yield clubsModule.updateClubLogo(_id, image);
        self.setNewLogo(newLogo);
      } catch (error) {
        console.log(error)
      } 
    }), 
    setNewLogo(newLogo) {
      const { _id } = self.currentClub.club;
      const clubIndex = self.clubs.findIndex(club => club._id === _id);
      const newClub = {...self.currentClub, club: {...self.currentClub.club, logo: newLogo }};
      self.currentClub = { ...newClub };
      self.clubs[clubIndex] = { ...newClub };
    }, 
    switchClub: flow(function* switchClub(clubId){  
      const { MetaStore } = getParent(self);
      const { location: { pathname } } = history;
      MetaStore.setIsLoading(true);
      
      const club = yield clubsModule.getClubById(clubId);
      self.setClub(club);
      const params = pathname.split("/");
      params.shift();
      if (params.length > 1) {
        history.push(`/${params[0]}`);
      };
      MetaStore.setIsLoading(false);
    })
  }));

export default ClubsStore;
